import withLanguageState, { WithLanguageProps } from 'enhancers/withLanguageState';
import * as React from 'react';
import styled from 'styled-components';

interface IProps {
  Country: string;
  CountryCode: string;
  Year: string;
}

type Props = IProps & WithLanguageProps;

export const PastWinner: React.SFC<Props> = props => {
  return (
    <Container>
      <FlagContainer
        style={{
          backgroundImage: `url(https://www.countryflags.io/${
            props.CountryCode
          }/flat/64.png)`
        }}
      />
      <Title>{props.getText(props.Country)}</Title>
      <Year>{props.getText(props.Year)}</Year>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const Title = styled.span`
  font-size: 24px;
  font-weight: bold;
  text-transform: uppercase;
  margin: 27px 0 0;
`;

const Year = styled.span`
  font-size: 15px;
  margin: 18px 0 0;
`;
const FlagContainer = styled.div`
  width: 42px;
  height: 42px;
  border-radius: 100%;
  overflow: hidden;
  border: 1px solid white;
  background-position: center;
`;

export default withLanguageState(PastWinner);



// WEBPACK FOOTER //
// ./src/components/PastWinner/PastWinner.tsx